export const DashboardAlertSeverities = ['critical', 'warning'] as const;
/**
 * アラートの警戒度
 */
export type DashboardAlertSeverity = (typeof DashboardAlertSeverities)[number];

export const DashboardAlertDirections = ['excess', 'shortage'] as const;
/**
 * アラートの向き
 */
export type DashboardAlertDirection = (typeof DashboardAlertDirections)[number];

export const DashboardAlertSettingsValueTypes = [
  'consecutiveMonths',
  'ratioThreshold',
  'momChangeRateThreshold',
  'minQuantityThreshold',
] as const;
/**
 * アラート設定種類のタイプ
 */
export type DashboardAlertSettingsValueType = (typeof DashboardAlertSettingsValueTypes)[number];

/**
 * ダッシュボードのキーごとの設定値
 */
export type DashboardAlertSettingInKey = Record<DashboardAlertSettingsValueType, string>;

/**
 * ダッシュボードの警戒度ごとの設定値
 */
export type DashboardAlertSettingInSeverity = Record<DashboardAlertDirection, DashboardAlertSettingInKey>;

/**
 * ダッシュボードアラート設定のType
 */
export type DashboardAlertSetting = Record<DashboardAlertSeverity, DashboardAlertSettingInSeverity>;

/**
 * 設定変更のinputバリデーション
 * @param value - 値
 * @param key - イベントが発生したinputのキー
 */
export const dashboardAlertSettingValidation = (value: string, key: DashboardAlertSettingsValueType): string => {
  if (!value) {
    return '値を入力してください';
  }
  const x = Number(value);
  if (!Number.isFinite(x)) {
    return '不正な値が入力されています。';
  }

  switch (key) {
    case 'consecutiveMonths':
      if (!Number.isSafeInteger(x) || x < 0) {
        return '月は0以上の整数で入力してください。';
      }
      break;
    case 'ratioThreshold':
    case 'momChangeRateThreshold':
      if (x >= 10000 || x < 0) {
        return 'パーセンテージは0以上10000より小さい範囲で入力してください。';
      }
      if ((value.split('.')[1] || '').length > 2) {
        return '小数点以下は2桁以内で入力してください。';
      }
      break;
    case 'minQuantityThreshold':
      if (x < 0) {
        return '数量は0以上の数値で入力してください。';
      }
      if ((value.split('.')[0] || '').length > 25 || (value.split('.')[1] || '').length > 6) {
        return '数量が入力できる制限を超えています。';
      }
  }
  return '';
};

export const DEFAULT_DASHBOARD_ALERT_SETTING: DashboardAlertSetting = {
  critical: {
    excess: {
      consecutiveMonths: '2',
      ratioThreshold: '50',
      momChangeRateThreshold: '50',
      minQuantityThreshold: '100',
    },
    shortage: {
      consecutiveMonths: '2',
      ratioThreshold: '150',
      momChangeRateThreshold: '200',
      minQuantityThreshold: '100',
    },
  },
  warning: {
    excess: {
      consecutiveMonths: '2',
      ratioThreshold: '80',
      momChangeRateThreshold: '75',
      minQuantityThreshold: '100',
    },
    shortage: {
      consecutiveMonths: '2',
      ratioThreshold: '120',
      momChangeRateThreshold: '125',
      minQuantityThreshold: '100',
    },
  },
};
